import { Slot } from '../types';
import { CustomSlot } from './custom-slot';

export function whitespaceSlot<RawData = undefined>(
  x: number,
  y: number,
  width: number,
  height: number,
  gridOptions?: {
    style?: React.CSSProperties;
    overrideGridStyles?: boolean;
  },
): Slot<RawData> {
  return new CustomSlot<RawData>(
    { x, y },
    width,
    height,
    true,
    () => null,
    {
      style: gridOptions?.style,
      overrideGridStyles: gridOptions?.overrideGridStyles,
    },
    'whitespace',
  );
}
